<div class="mt-2">
  <ag-shr-editor-toolbar
    [title]="'Signed Policies'"
    [isEditVisible]="false"
    [agentDbId]="agentDbId"
    (clickEdit)="signedPoliciesModalComponent.showModal()"
  ></ag-shr-editor-toolbar>

  <div class="row my-2">
    <ag-shr-user-agreements-grid
      [canEdit]="false"
      [canCreate]="false"
      [canDelete]="false"
      [agentId]="agentDbId"
      [isEditable]="false"
      [sourceType]="sourceType()"
    ></ag-shr-user-agreements-grid>
  </div>
</div>

<ag-shr-modal-window
  #signedPoliciesModalComponent
  [title]="'Signed Policies'"
  [showSaveButton]="false"
  [width]="'75%'"
  [height]="'auto'"
>
  @if (signedPoliciesModalComponent?.popupComponent?.visible ?? false) {
    <ag-shr-user-agreements-grid
      [canEdit]="false"
      [canCreate]="false"
      [canDelete]="false"
      [agentId]="agentDbId"
      [isEditable]="false"
      [sourceType]="sourceType()"
    ></ag-shr-user-agreements-grid>
  }
</ag-shr-modal-window>
